import * as i0 from '@angular/core';
import * as i1 from './tabset.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '../badge/badge.component';
import * as i6 from './tabset.component';
import * as i7 from '../shared/shared.module';
import * as i8 from '../badge/badge.module';
export const NbTabsetModuleNgFactory:i0.NgModuleFactory<i1.NbTabsetModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bh = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_s = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_be = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵEmptyOutletComponent = (<any>(null as any));
var _decl0_38:i5.NbBadgeComponent = (<any>(null as any));
var _decl0_39:i6.NbTabsetComponent = (<any>(null as any));
var _decl0_40:i6.NbTabComponent = (<any>(null as any));
var _decl0_41:i2.AsyncPipe = (<any>(null as any));
var _decl0_42:i2.UpperCasePipe = (<any>(null as any));
var _decl0_43:i2.LowerCasePipe = (<any>(null as any));
var _decl0_44:i2.JsonPipe = (<any>(null as any));
var _decl0_45:i2.SlicePipe = (<any>(null as any));
var _decl0_46:i2.DecimalPipe = (<any>(null as any));
var _decl0_47:i2.PercentPipe = (<any>(null as any));
var _decl0_48:i2.TitleCasePipe = (<any>(null as any));
var _decl0_49:i2.CurrencyPipe = (<any>(null as any));
var _decl0_50:i2.DatePipe = (<any>(null as any));
var _decl0_51:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_52:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_53:i2.KeyValuePipe = (<any>(null as any));
var _decl0_54:i7.NbSharedModule = (<any>(null as any));
var _decl0_55:i8.NbBadgeModule = (<any>(null as any));
var _decl0_56:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_57:i0.ElementRef<any> = (<any>(null as any));
function _View_NbTabsetComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.fullWidthValue;
  currVal_0;
}
function _View_NbTabsetComponent_1_2():void {
  if (_any.tabIcon) {
    var _any:any = (null as any);
    const currVal_0:any = _any.tabIcon;
    currVal_0;
  }
}
function _View_NbTabsetComponent_1_3():void {
  if (_any.tabTitle) {
    var _any:any = (null as any);
    const currVal_0:any = _any.tabTitle;
    currVal_0;
  }
}
function _View_NbTabsetComponent_1_4():void {
  if (_any.badgeText) {
    var _any:any = (null as any);
    const currVal_0:any = _any.badgeText;
    currVal_0;
    const currVal_1:any = _any.badgePosition;
    currVal_1;
    const currVal_2:any = _any.badgeStatus;
    currVal_2;
  }
}
function _View_NbTabsetComponent_1_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.responsive;
  currVal_0;
  const currVal_1:any = _any.active;
  currVal_1;
  const currVal_2:any = _any.disabled;
  currVal_2;
  const currVal_3:any = (_any.disabled? (0 - 1): 0);
  currVal_3;
  const currVal_4:any = _any.tabIcon;
  currVal_4;
  const currVal_5:any = _any.tabTitle;
  currVal_5;
  const currVal_6:any = _any.badgeText;
  currVal_6;
  const pd_7:any = ((<any>_decl0_39.selectTab(_any)) !== false);
  const pd_8:any = ((<any>_any.preventDefault()) !== false);
}
function _View_NbTabsetComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.tabs;
  currVal_0;
}
function _View_NbTabComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_40.disabled;
  currVal_0;
  const currVal_1:any = _decl0_40.activeValue;
  currVal_1;
}
function _View_NbTabComponent_2_1():void {
  if (_decl0_40.init) { var _any:any = (null as any); }
}
function _View_NbTabComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_40.init;
  currVal_0;
}
